export default "__VITE_ASSET__DeYiwExL__"